import { create } from 'zustand';

interface MapState {
  longitude: number;
  latitude: number;
  zoom: number;
  viewMode: '2d' | '3d';
  setViewState: (lon: number, lat: number, zoom: number) => void;
  setViewMode: (mode: '2d' | '3d') => void;
}

export const useMapStore = create<MapState>((set) => ({
  longitude: 2.03,
  latitude: 48.95,
  zoom: 13,
  viewMode: '2d',
  setViewState: (longitude, latitude, zoom) => set({ longitude, latitude, zoom }),
  setViewMode: (viewMode) => set({ viewMode }),
}));
